import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ed66c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginbox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "翼辉产品授权激活系统", -1))
const _hoisted_3 = { class: "loginbox-in" }
const _hoisted_4 = { class: "userbox" }
const _hoisted_5 = ["onKeyup"]
const _hoisted_6 = { class: "background" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "show_box" }

import { onMounted } from "vue";
import { reactive } from 'vue';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

let baseURL:string;
let route = useRouter()
if (process.env.VUE_APP_FLAG == "development") {
  baseURL = "http://localhost:8082/";
} else if (process.env.VUE_APP_FLAG == "production") {
  baseURL = "api/";
}

const data = reactive({
        regcode: route.currentRoute.value.params.id,
        Info: "",
        SN: "",
        Lic: "",
  })

onMounted(() => {
  if(route.currentRoute.value.params.id != undefined) {
    getLic();
  }
});

/*
function messageSendlisten(event): void {
      if (event.keyCode == 13) {
        event.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
}*/

function clear(): void {
      data.Info = "";
      data.SN = "";
      data.Lic = "";
      data.regcode = route.currentRoute.value.params.id;
    }    
function getLic(): void {
  if(data.regcode == undefined){
    var id = route.currentRoute.value.params.id;
  } else {
    id = data.regcode;
  }
  fetch((baseURL + "licsrv/"), {
  method: "post",
  body: JSON.stringify({
    RegCode: id ,
  }),
  headers: {
    "Content-Type": "application/json",
  },
  })
  .then((res) => {
    return res.json();
  })
  .then((res) => {
    if(res.ErrString == "Clear"){
      data.Info = "License:";
      data.SN = "SN: " + res.SN;
      data.Lic = res.Lic;
      } else if (res.ErrString == "WRONG SN") {
      data.Info = "Warning:";
      data.SN = "Wrong SN Code";
      data.Lic = "Wrong SN Code";
      } else if (res.ErrString == "SN USED") {
      data.Info = "Warning:";
      data.SN = "This SN Code is USESD";
      data.Lic = "This SN Code is USESD";
      } else if (res.ErrString == "SN for Other Service") {
      data.Info = "Warning This SN is for Service:";
      data.SN = res.SN;
      data.Lic = res.SN;
      } else if (res.ErrString == "SN EXPIRE") {
      data.Info = "Warning:";
      data.SN = "This SN is expire you may need to contact sales";
      data.Lic = "This SN is expire you may need to contact sales";
    } else if (res.ErrString == "BSP UID NOT MATCH") {
      data.Info = "Warning:";
      data.SN = "BSP UID is not match";
      data.Lic = "BSP UID is not match";
    } else {
      data.Info = "Warning:";
      data.SN = "Something Wrong with Service";
      data.Lic = "Something Wrong with Service";
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          style: {"resize":"none"},
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.regcode) = $event)),
          class: "regcode",
          placeholder: "PLEASE Paste Registration Code HERE",
          onKeyup: _withKeys(getLic, ["enter"])
        }, null, 40, _hoisted_5), [
          [_vModelText, data.regcode]
        ])
      ]),
      _createElementVNode("button", {
        class: "register_btn",
        onClick: getLic
      }, "Generate"),
      _createElementVNode("button", {
        class: "clear_btn",
        onClick: clear
      }, "Clear")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(data.Info), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, _toDisplayString(data.Lic), 1)
      ])
    ])
  ]))
}
}

})